<template>
  <div>
    <van-nav-bar
        fixed
        :border="false"
    >
        <template #left>
            <!-- <span v-if="$route.name === 'mine'" class="website">{{addr ? `${addr.slice(0, 6)}...${addr.slice(addr.length - 6)}` : '--'}}</span>
            <template v-else>
                <img class="logo" src="../assets/images/m.38cc7705.svg">
                <span class="def-text website">TRONCLUBS.COM</span>
            </template> -->
            <img class="logo" src="../assets/images/m.38cc7705.svg">
            <span class="def-text website">{{addr ? `${addr.slice(0, 6)}...${addr.slice(addr.length - 6)}` : '-/-'}}</span>
        </template>
        <template #right>
            <van-popover
                v-model="showPopover"
                trigger="click"
                :actions="actions"
                @select="onSelect"
                class="r-icon"
                theme="dark"
                >
                    <template #reference>
                        <img src="../assets/images/en.png" style="width:5.2rem;height:5.2rem;">
                    </template>
                </van-popover>
            <img class="r-icon" src="../assets/images/notice.png" @click="$router.push('/notification')">
            <img class="r-icon" src="../assets/images/service.png" @click="showServiceEmail">
        </template>
    </van-nav-bar>
    <van-popup v-model="emailVisible" style="background-color: #d6b593;width:300px;">
        <div class="emailBox">
            <div style="margin-bottom: 10px;"><van-icon name="chat-o" size="40"/>{{$t('common.supportTips')}}</div>
            E-mail: {{serviceEmail || 'n/a'}}
        </div>
    </van-popup>
  </div>
</template>

<script>
export default {
    name: 'navbar',
    data() {
        return {
            showPopover: false,
            // 通过 actions 属性来定义菜单选项
            actions: [
                { text: 'English', lang: 'en_US' },
                { text: '繁體中文', lang: 'zh_HK' },
                { text: 'Türkçe', lang: 'tr_TR' },
                { text: 'Español', lang: 'es_ES' },
                { text: ' بالعربية ', lang: 'en_XA' },
                { text: 'português', lang: 'pt_PT' },
                { text: 'Deutsch', lang: 'de_DE' },
                { text: 'français', lang: 'fr_FR' },
                { text: '日本語', lang: 'ja_JP' },
                { text: '한국어', lang: 'ko_KR' },
                { text: 'italiano', lang: 'it' },
                { text: 'русский', lang: 'ru' }
            ],
            addr: localStorage.getItem('addr'),
            serviceEmail: '',
            emailVisible: false
        }
    },
     methods: {
        _fetch() {
            this.token = localStorage.getItem('token');
            this.apiV1({
                method: 'get',
                url: '/task',
                headers: {'Authorization': this.token}
            }).then(response => {
                const { success, data } = response.data;
                if (success) {
                    this.serviceEmail = data.serviceEmail;
                }
            })
        },
        onSelect(action) {
            this.$i18n.locale = action.lang;
            localStorage.setItem('language', action.lang);
        },
        showServiceEmail() {
            this._fetch();
            this.emailVisible = true;
        }
    },
    mounted() {
    }
}
</script>

<style scoped lang="less">
.logo {
    width: 10.667rem;
    height: 10.667rem;
    margin-right: 1.6rem;
}
.website {
    font-weight: bold;
    color: @app-theme-color1;
}
.r-icon {
    padding: 1rem;
    border-radius: 2rem;
    background: @app-theme-color1;
    width: 5.2rem;
    height: 5.2rem;
}
.r-icon + .r-icon {
    margin-left: 2rem;
}
.emailBox {
    font-size: 16px;
    padding: 6rem 8rem;
}
</style>